import Vue from 'vue'
import Router from 'vue-router'
import Home from './home'
import Login from './view/Login/Login'
import Index from './view/Index'
import LearnIndex from './view/Index/Index'
import Progress from './view/Progress/Progress'
import Course from './view/Learning/Course/Course'
import Question from './view/Question/Question'
import Test from './view/Learning/Test/Test'
import TestResult from './view/Learning/TestResult/TestResult'
import Record from './view/Learning/Record/Record'
import Learning from './view/Learning/Learning'
import Success from './view/Question/Success'


//组件模块

export const learnOrProgressRoutes = [{
        path: '/learning',
        name: 'learning',
        component: Progress,
        meta: {
            code: 'learning',
            nav: true,
            type: 'learning',
            breadcrumb: [{
                name: '首頁',
                url: '/index'
            }, {
                name: '課程學習',
                url: '/learning'
            }]
        }
    },
    {
        path: '/learning/course',
        name: 'Course',
        component: Course,
        meta: {
            code: 'Course',
            nav: false,
            type: 'learning',
            breadcrumb: [{
                name: '首頁',
                url: '/index'
            }, {
                name: '課程學習',
                url: '/learning'
            }, {
                name: '課件學習',
                url: '/learning/course'
            }]
        }
    }
]

export const learnRoutes = [{
    path: '/index',
    name: 'eLearningIndex',
    component: LearnIndex,
    meta: {
        code: 'index',
        nav: true,
        type: 'index'
    }
}, {
    path: '/learning',
    name: 'learning',
    component: Learning,
    meta: {
        code: 'learning',
        nav: true,
        type: 'learning',
        breadcrumb: [{
            name: '首頁',
            url: '/index'
        }, {
            name: '課程學習',
            url: '/learning'
        }]
    },
    children: learnOrProgressRoutes
}, {
    path: '/question',
    name: 'Question',
    component: Question,
    meta: {
        code: 'question',
        nav: false,
        type: 'question',
        breadcrumb: [{
            name: '首頁',
            url: '/index'
        }, {
            name: '問卷調查',
            url: '/question'
        }]
    }
}, {
    path: '/success',
    name: 'Success',
    component: Success,
    meta: {
        code: 'Success',
        nav: false,
        type: 'Success',
        breadcrumb: [{
            name: '首頁',
            url: '/index'
        }, {
            name: '問卷調查',
            url: '/question'
        }, {
            name: '提交成功',
            url: '/success'
        }]
    }
}, {
    path: '/learning/test',
    name: 'test',
    component: Test,
    meta: {
        code: 'Test',
        nav: false,
        type: 'record',
        breadcrumb: [{
            name: '首頁',
            url: '/index'
        }, {
            name: '課程學習',
            url: '/learning'
        }, {
            name: '模擬考試',
            url: '/learning/test'
        }]
    }
}, {
    path: '/learning/testresult',
    name: 'testresult',
    component: TestResult,
    meta: {
        code: 'TestResult',
        nav: false,
        type: 'record',
        breadcrumb: [{
            name: '首頁',
            url: '/index'
        }, {
            name: '課程學習',
            url: '/learning'
        }, {
            name: '模擬考試記錄',
            url: "/learning/record"
        }, {
            name: '模擬考試結果',
            url: '/learning/testresult'
        }]
    }
}, {
    path: '/learning/record',
    name: 'record',
    component: Record,
    meta: {
        code: 'Record',
        nav: true,
        type: 'record',
        breadcrumb: [{
            name: '首頁',
            url: '/index'
        }, {
            name: '課程學習',
            url: '/learning'
        }, {
            name: '模擬考試記錄',
            url: "/learning/record"
        }]
    }
}]


Vue.use(Router)

const routes = [{
    path: '/',
    name: 'eLearning',
    component: Home
}, {
    path: '/index',
    name: 'index',
    component: Index,
    children: learnRoutes
}, {
    path: '/login',
    name: 'login',
    component: Login
}]

export default new Router({
    routes: routes
})